import { SecondFactorProofMethod } from './types'

export const normalizeBackupCode = (raw: string): string =>
    String(raw)
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '')

export const normalizeOtpCode = (raw: string, length = 6): string => raw.replace(/\D/g, '').slice(0, length)

export const isOtpComplete = (code: string, length = 6): boolean => normalizeOtpCode(code, length).length === length

export const isBackupCodeComplete = (code: string): boolean => normalizeBackupCode(code).length >= 8

export const needsProofCode = (proofMethod: SecondFactorProofMethod, codeLength?: number | null): boolean => {
    if (!proofMethod || proofMethod === 'none') {
        return false
    }
    if (codeLength === undefined || codeLength === null) {
        return true
    }
    return codeLength > 0
}

export const isProofCodeReady = (proofMethod: SecondFactorProofMethod, code: string, codeLength: number): boolean => {
    if (!needsProofCode(proofMethod, codeLength)) {
        return true
    }
    if (proofMethod === 'recovery') {
        return isBackupCodeComplete(code)
    }
    return isOtpComplete(code, codeLength || 6)
}
